
    import {loadShare} from "@module-federation/runtime";
    const importMap = {
      
        "@okta/okta-auth-js": async () => {
          let pkg = await import("__mf__virtual/wmg1_mf_2_container__prebuild___mf_0_okta_mf_1_okta_mf_2_auth_mf_2_js__prebuild__.js");
            return pkg;
        }
      ,
        "@okta/okta-react": async () => {
          let pkg = await import("__mf__virtual/wmg1_mf_2_container__prebuild___mf_0_okta_mf_1_okta_mf_2_react__prebuild__.js");
            return pkg;
        }
      ,
        "@typeform/embed-react": async () => {
          let pkg = await import("__mf__virtual/wmg1_mf_2_container__prebuild___mf_0_typeform_mf_1_embed_mf_2_react__prebuild__.js");
            return pkg;
        }
      ,
        "react": async () => {
          let pkg = await import("__mf__virtual/wmg1_mf_2_container__prebuild__react__prebuild__.js");
            return pkg;
        }
      ,
        "react-dom": async () => {
          let pkg = await import("__mf__virtual/wmg1_mf_2_container__prebuild__react_mf_2_dom__prebuild__.js");
            return pkg;
        }
      ,
        "react-helmet-async": async () => {
          let pkg = await import("__mf__virtual/wmg1_mf_2_container__prebuild__react_mf_2_helmet_mf_2_async__prebuild__.js");
            return pkg;
        }
      ,
        "react-i18next": async () => {
          let pkg = await import("__mf__virtual/wmg1_mf_2_container__prebuild__react_mf_2_i18next__prebuild__.js");
            return pkg;
        }
      ,
        "react-redux": async () => {
          let pkg = await import("__mf__virtual/wmg1_mf_2_container__prebuild__react_mf_2_redux__prebuild__.js");
            return pkg;
        }
      ,
        "react-router-dom": async () => {
          let pkg = await import("__mf__virtual/wmg1_mf_2_container__prebuild__react_mf_2_router_mf_2_dom__prebuild__.js");
            return pkg;
        }
      
    }
      const usedShared = {
      
          "@okta/okta-auth-js": {
            name: "@okta/okta-auth-js",
            version: "7.14.0",
            scope: ["default"],
            loaded: false,
            from: "wmg1-container",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"@okta/okta-auth-js"}' must be provided by host`);
              }
              usedShared["@okta/okta-auth-js"].loaded = true
              const {"@okta/okta-auth-js": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = false && "@okta/okta-auth-js" === "react"
                ? (res?.default ?? res)
                : {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "^7.14.0",
              
            }
          }
        ,
          "@okta/okta-react": {
            name: "@okta/okta-react",
            version: "6.10.0",
            scope: ["default"],
            loaded: false,
            from: "wmg1-container",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"@okta/okta-react"}' must be provided by host`);
              }
              usedShared["@okta/okta-react"].loaded = true
              const {"@okta/okta-react": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = false && "@okta/okta-react" === "react"
                ? (res?.default ?? res)
                : {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "^6.10.0",
              
            }
          }
        ,
          "@typeform/embed-react": {
            name: "@typeform/embed-react",
            version: "3.8.0",
            scope: ["default"],
            loaded: false,
            from: "wmg1-container",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"@typeform/embed-react"}' must be provided by host`);
              }
              usedShared["@typeform/embed-react"].loaded = true
              const {"@typeform/embed-react": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = false && "@typeform/embed-react" === "react"
                ? (res?.default ?? res)
                : {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: false,
              requiredVersion: "^3.8.0",
              
            }
          }
        ,
          "react": {
            name: "react",
            version: "18.3.1",
            scope: ["default"],
            loaded: false,
            from: "wmg1-container",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"react"}' must be provided by host`);
              }
              usedShared["react"].loaded = true
              const {"react": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = false && "react" === "react"
                ? (res?.default ?? res)
                : {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "^18.3.1",
              
            }
          }
        ,
          "react-dom": {
            name: "react-dom",
            version: "18.3.1",
            scope: ["default"],
            loaded: false,
            from: "wmg1-container",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"react-dom"}' must be provided by host`);
              }
              usedShared["react-dom"].loaded = true
              const {"react-dom": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = false && "react-dom" === "react"
                ? (res?.default ?? res)
                : {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "^18.3.1",
              
            }
          }
        ,
          "react-helmet-async": {
            name: "react-helmet-async",
            version: "2.0.5",
            scope: ["default"],
            loaded: false,
            from: "wmg1-container",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"react-helmet-async"}' must be provided by host`);
              }
              usedShared["react-helmet-async"].loaded = true
              const {"react-helmet-async": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = false && "react-helmet-async" === "react"
                ? (res?.default ?? res)
                : {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "^2.0.5",
              
            }
          }
        ,
          "react-i18next": {
            name: "react-i18next",
            version: "15.0.2",
            scope: ["default"],
            loaded: false,
            from: "wmg1-container",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"react-i18next"}' must be provided by host`);
              }
              usedShared["react-i18next"].loaded = true
              const {"react-i18next": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = false && "react-i18next" === "react"
                ? (res?.default ?? res)
                : {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "^15.0.2",
              
            }
          }
        ,
          "react-redux": {
            name: "react-redux",
            version: "8.1.0",
            scope: ["default"],
            loaded: false,
            from: "wmg1-container",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"react-redux"}' must be provided by host`);
              }
              usedShared["react-redux"].loaded = true
              const {"react-redux": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = false && "react-redux" === "react"
                ? (res?.default ?? res)
                : {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "^8.1.0",
              
            }
          }
        ,
          "react-router-dom": {
            name: "react-router-dom",
            version: "6.26.2",
            scope: ["default"],
            loaded: false,
            from: "wmg1-container",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"react-router-dom"}' must be provided by host`);
              }
              usedShared["react-router-dom"].loaded = true
              const {"react-router-dom": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = false && "react-router-dom" === "react"
                ? (res?.default ?? res)
                : {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "^6.26.2",
              
            }
          }
        
    }
      const usedRemotes = [
                {
                  entryGlobalName: "https://rmw.wmg1.com/mf-manifest.json?1776440551089",
                  name: "ReleaseManagementApp",
                  type: "var",
                  entry: "https://rmw.wmg1.com/mf-manifest.json?1776440551089",
                  shareScope: "default",
                }
          ,
                {
                  entryGlobalName: "https://module.musiciq.wmgapps.net/mf-manifest.json?1776440551089",
                  name: "MusicIqChatbotApp",
                  type: "var",
                  entry: "https://module.musiciq.wmgapps.net/mf-manifest.json?1776440551089",
                  shareScope: "default",
                }
          ,
                {
                  entryGlobalName: "https://aim.dsc-wmg.com/mf-manifest.json?1776440551089",
                  name: "AimApp",
                  type: "var",
                  entry: "https://aim.dsc-wmg.com/mf-manifest.json?1776440551089",
                  shareScope: "default",
                }
          ,
                {
                  entryGlobalName: "https://videomgmt.wmg.com/v2/mf-manifest.json?1776440551089",
                  name: "VideoApp",
                  type: "var",
                  entry: "https://videomgmt.wmg.com/v2/mf-manifest.json?1776440551089",
                  shareScope: "default",
                }
          ,
                {
                  entryGlobalName: "https://ui.prod.co-op.wmg.com/v2/mf-manifest.json?1776440551089",
                  name: "CoopApp",
                  type: "var",
                  entry: "https://ui.prod.co-op.wmg.com/v2/mf-manifest.json?1776440551089",
                  shareScope: "default",
                }
          ,
                {
                  entryGlobalName: "?1776440551089",
                  name: "AIConsentApp",
                  type: "var",
                  entry: "?1776440551089",
                  shareScope: "default",
                }
          
      ]
      export {
        usedShared,
        usedRemotes
      }
      